import { render, staticRenderFns } from "./LoadingPreview.vue?vue&type=template&id=28cffcca&scoped=true"
import script from "./LoadingPreview.vue?vue&type=script&lang=ts"
export * from "./LoadingPreview.vue?vue&type=script&lang=ts"
import style0 from "./LoadingPreview.vue?vue&type=style&index=0&id=28cffcca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cffcca",
  null
  
)

export default component.exports